module.exports = __webpack_public_path__ + "img/icon14.c34bf715.svg";